import { render, staticRenderFns } from "./MoleculeEditionBillingAcademies.vue?vue&type=template&id=19fc5ec8"
import script from "./MoleculeEditionBillingAcademies.vue?vue&type=script&lang=js"
export * from "./MoleculeEditionBillingAcademies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports